import React, { useState } from 'react'
import { translateLabel } from 'components/shared/AssetDelivery/utils'
import { Asset } from './types'
import { ENTER_KEY_CODE } from './utils'

interface Label {
  name: string
  systemName: string
}

interface Props {
  asset: Asset
  preDefinedLabels: Label[]
  onChange: (labels: string[]) => void
}

function UploadGroupLabels({ asset, preDefinedLabels = [], onChange }: Props) {
  const [labelSearch, setLabelSearch] = useState<string>('')

  const selectedLabels = asset.labels || []
  const preDefinedLabelNames = preDefinedLabels.map(l => l.systemName)
  const labelMatchingSearch = preDefinedLabels.find(l => labelSearch && labelSearch === l.name.substring(0, labelSearch.length))
  const customLabels = selectedLabels.filter(sl => !preDefinedLabelNames.includes(sl))

  function toggleSelectedLabel(label: string, checked: boolean) {
    const labels = checked
      ? Array.from(new Set([...selectedLabels, label]))
      : selectedLabels.filter(sl => sl !== label)

    onChange(labels)
  }

  function handleSearchKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if (labelSearch && event.keyCode === ENTER_KEY_CODE) {
      toggleSelectedLabel(labelMatchingSearch?.systemName || labelSearch, true)
    }
  }

  return (
    <div className="group-labels">
      <input
        type="text"
        placeholder="Søk etter merkelapp eller opprett ny"
        value={labelSearch}
        onChange={e => setLabelSearch(e.target.value)}
        onKeyDown={handleSearchKeyDown}
        ref={input => input && input.focus()}
      />
      <div className="labels-wrapper">
        {[...preDefinedLabelNames, ...customLabels].map((label) => (
          <label
            key={label}
            className={(labelMatchingSearch && labelMatchingSearch.systemName === label) ? 'search-match' : ''}
          >
            <input
              type="checkbox"
              checked={selectedLabels.includes(label)}
              onChange={e => toggleSelectedLabel(label, e.target.checked)}
            />
            {translateLabel(label, preDefinedLabels)}
          </label>
        ))}
      </div>
    </div>
  )
}

export default UploadGroupLabels
